import React, { useState, useEffect } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinancePaymentsList = ({ activeYear, data }) => {
  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "paid_by_staff_name", label: "پرداخت کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    { path: "amount", label: "مبلغ" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{
            form: "creditor-debt-payment-form",
            cache: e.creditor_id,
            edit: e,
          }}
          Delete={{ route: "creditors/payment", id: e.id }}
          Print={{ route: `creditor-payment-receipt/${e.creditor_id}/${e.id}`}}
        />
      ),
    },
  ];

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      getRows(data?.data[0]?.payments?.filter(
          (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      ));
    }
  }, [activeYear]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payments}</p>
      <Table
        data={rows}
        columns={paymentsColumn}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePaymentsList;
